import { extractId } from "../../contexts/ProductsContext/preorderHelpers";

export const handlePreOrderProductsForViewing = (products) => {
  const productVariants = [];

  products.forEach(({ variants = {}, ...product }) => {
    const items = Object.entries(variants).map(([variantId, variant]) => ({
      ...product,
      ...variant,
      id: variantId,
      productId: product.id,
      productTitle: product.title,
    }));

    productVariants.push(items);
  });

  return productVariants.flat(1);
};

export const handleProductEdgesForViewing = (items, edges = []) =>
  items.concat(
    edges.map(({ node, cursor }) => ({
      ...node,
      id: extractId(node.id),
      images: node.images?.edges.map((image) => ({ ...image.node })),
      variants: node.variants?.edges.map((variant) => ({ ...variant.node, id: extractId(variant.node.id) })) || null,
      cursor,
    }))
  );

export const handleCollectionEdgesForViewing = (edges = []) =>
  edges.map(({ node }) => ({
    ...node,
    id: Number(extractId(node.id)),
  }));

export const handleProductVariantEdgesForViewing = ({ edges = [] }) =>
  edges.map(({ node, cursor }) => ({
    ...node,
    cursor,
    id: extractId(node.id),
  }));

export const addVariantsToProduct = ({ data, id, variants }) =>
  data.map((product) => {
    if (product.id === id) {
      return {
        ...product,
        variants: handleProductVariantEdgesForViewing(variants),
      };
    }

    return product;
  });

export const addProductVariants = ({ products, variants }) =>
  products.map((product) => {
    const productItem = variants.find(({ productId }) => productId === product.id);

    if (productItem) {
      return {
        ...product,
        variants: handleProductVariantEdgesForViewing(productItem.variants),
      };
    }

    return product;
  });
